import { useMemo, useState } from "react";
import { useAppendSearchParams } from "./useAppendSearchParams";

export interface PaginationModel {
  page: number;
  pageSize: number;
}

export const usePagingSearchParams = (initPage = 1, initPageSize = 10, fromSearchParams = true): [
  PaginationModel,
  (newPage: PaginationModel) => void,
] => {
  const [searchParams, setSearchParams] = useAppendSearchParams();
  const [localParams, setLocalParams] = useState<PaginationModel>({
    page: initPage,
    pageSize: initPageSize,
  });

  const page = useMemo(() => {
    if (!fromSearchParams) return {
      page: localParams.page || initPage,
      pageSize: localParams.pageSize || initPageSize,
    }
    return {
      page: parseInt(searchParams.get('page') || initPage.toString()),
      pageSize: parseInt(searchParams.get('pageSize') || initPageSize.toString()),
    };
  }, [searchParams, initPage, fromSearchParams, localParams]);

  const setPage = fromSearchParams ? (newPage: PaginationModel) => {
    const obj: Partial<PaginationModel> = {
      page: newPage.page,
      pageSize: newPage.pageSize,
    };

    setSearchParams(obj);
  } : (newPage: PaginationModel) => {
    const obj: PaginationModel = {
      page: newPage.page,
      pageSize: newPage.pageSize,
    };

    setLocalParams(obj);
  };

  return [page, setPage];
}
